module.exports = __webpack_public_path__ + "img/116.9f84bc3e.png";